<main id="content-page">
        <div class="container main-panel">
            <div *ngIf="sent" class="row article-row">
                <div class="col-lg-12 col-md-12 col-sm-12 margin-left-20">
                    <h3>
                        Thank you for submitting your request
                    </h3>
                    Your message was sent successfully.
                </div>
            </div>
            <div *ngIf="!sent" class="row article-row">               
                <div class="col-lg-12 col-md-12 col-sm-12">
                    <div class="article-wrap">
                        <div class="article-inner-container">
                            <div class="row">
                                <div class="col-lg-12 col-md-12 col-sm-12">
                                    <div class="text-center">
                                        <h1>LawShelf Contact Form</h1>
                                    </div>
                                    <div>
                                        <br />
                                        This contact form is for users who need assistance using the LawShelf web site.<p></p>  We <span style="font-weight: 700; color: maroon">do not</span> provide personalized legal advice.
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-6 col-md-6 col-sm-12">
                                    <form id="contactUsForm" (ngSubmit)="doContactUs(contactUsForm)" #contactUsForm="ngForm">
                                        <span *ngIf="!LoginComponent || !LoginComponent.user">
                                            <h3>Email</h3>
                                            <input class="form-control" ngModel id="Email" name="Email" required email placeholder="Email" type="text" value="">                                
                                        </span>
                                        <span *ngIf="LoginComponent && LoginComponent.user">
                                            <h3>From: {{LoginComponent.user.FullName}}</h3>
                                        </span>
    
                                        <h3>Message</h3>
                                        <textarea class="form-control" required ngModel id="Message" name="Message" rows="5"></textarea>
                                        
                                        <input type="text" name="Comment" id="Comment"  ngModel style="width: 0px; height: 0px;display: none"/>
                                        <br />
                                        
                                        <div id="recaptcha" class="g-recaptcha" data-sitekey="6Lfsd3oUAAAAAAikfrD40gXwHdoXiJ1eYoBik6RY" style="height: 60px"></div>
                                        
                                        <button [disabled]="!contactUsForm.valid" type="submit" class="btn login-register-buttons" style="margin-top: 30px">Submit</button>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </main>
    